import { CreateElement } from 'vue';
import { InPlayerOverlayManifest } from './manifest';

const getCollisionMask = (current: number, previous: number): number => previous & current;
const isColliding = (mask: number): boolean => mask > 0;

export const getOverlayToDisplay = (manifests: InPlayerOverlayManifest[]): InPlayerOverlayManifest[] => {
  const sortedManifest = manifests
    .slice()
    .sort((a, b) => a.precedence - b.precedence)
    .reverse() // highest precedence in the front
  ;

  let colliderMask = 0;
  const acceptedManifest = [];
  for (const manifest of sortedManifest) {
    const collisionMask = getCollisionMask(colliderMask, manifest.position);

    if (isColliding(collisionMask)) {
      continue;
    }

    colliderMask = colliderMask | manifest.position;
    acceptedManifest.push(manifest);
  }
  // Highest precedence at the back
  return acceptedManifest.reverse();
};

export type AlignmentKey = (
  | 'fillVertical'
  | 'fillHorizontal'
  | 'alignTop'
  | 'alignRight'
  | 'alignBottom'
  | 'alignLeft'
)

export interface RenderDetails {
  component: Parameters<CreateElement>[0];
  alignment: Set<AlignmentKey>;
};

const masks = {
  fill: {
    horizontal: [
      0b100100100,
      0b001001001,
    ],
    vertical: [
      0b111000000,
      0b000000111,
    ],
  },
  alignments: [
    [0b111111000, ['alignTop']],
    [0b011011011, ['alignRight']],
    [0b000111111, ['alignBottom']],
    [0b110110110, ['alignLeft']],
  ] as [number, AlignmentKey[]][],
};

const isIntersecting = (value: number) => (mask: number): boolean => (
  (value & mask) > 0
);

const getAlignmentDetailsPositonBinary = (value: number): Set<AlignmentKey> => {
  const alignment = new Set<AlignmentKey>([]);
  const isIntersectingValue = isIntersecting(value);

  if (
    isIntersectingValue(masks.fill.horizontal[0]) &&
    isIntersectingValue(masks.fill.horizontal[1])
  ) {
    alignment.add('fillHorizontal');
  }

  if (
    isIntersectingValue(masks.fill.vertical[0]) &&
    isIntersectingValue(masks.fill.vertical[1])
  ) {
    alignment.add('fillVertical');
  }

  masks.alignments.forEach(([mask, alignmentKeys]) => {
    if (!isIntersectingValue(mask)) return;

    alignmentKeys.forEach((key) => {
      alignment.add(key);
    });
  });

  return alignment;
};

export const toRenderNodeOptions = ({ component, position }: InPlayerOverlayManifest): RenderDetails => ({
  component,
  alignment: getAlignmentDetailsPositonBinary(position),
});
